import React from "react";
import { DeleteConfirmConsts } from "./constants";
import { CommonButtonTexts } from "../../../enums/ButtonAttributesEnums";
import InputField from "../../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../../enums/InputFieldAttributesEnums";
import CustomerDatabaseService from "../../../services/customerDatabase.service";
import TNLoader from "../../../reusable-components/TNLoader";
import { message, Modal } from "antd";
import { useFormContext } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "../../../constants/QueryKeys";
import { DatabaseSections } from "../../../enums/DatabaseEnums";

export interface DeleteConfirmModalProps {
  isOpen?: boolean;
  handleClose: () => void;
  submitActionCall: (notes?: string) => Promise<void>;
  tabType: DatabaseSections;
  deletePending?: boolean;
}

const DeleteConfirmation = ({
  isOpen,
  handleClose,
  submitActionCall,
  tabType,
  deletePending,
}: DeleteConfirmModalProps) => {
  const { reset, getValues } = useFormContext();
  const queryClient = useQueryClient();

  const {
    TITLE,
    MODAL_WITH,
    MESSAGE,
    REASON_LABEL,
    REASON_PLACEHOLDER,
    REASON_NAME,
    DELETE_SUCCESS,
  } = DeleteConfirmConsts(tabType);

  const handleSubmitAction = async () => {
    await submitActionCall(getValues("archiveReason"));
    reset({
      [REASON_NAME]: "",
    });
  };

  const handleCancel = () => {
    reset({
      [REASON_NAME]: "",
    });
    handleClose();
  };

  return (
    <>
      <TNLoader isLoading={false} />
      <Modal
        title={TITLE}
        okText={CommonButtonTexts.CONFIRM}
        visible={isOpen}
        onCancel={handleCancel}
        onOk={() => handleSubmitAction()}
        width={MODAL_WITH}
        loading={deletePending}
        maskClosable={false}
        destroyOnClose={true}
      >
        <div>{MESSAGE}</div>
        <InputField
          type={InputfieldTypes.TEXT_AREA}
          name={REASON_NAME}
          label={REASON_LABEL}
          maxLength={500}
          textAreaRows={6}
          noResize
          requiredField
          placeholder={REASON_PLACEHOLDER}
        />
      </Modal>
    </>
  );
};

export default DeleteConfirmation;
